import { createFileRoute } from '@tanstack/react-router';
import { TermsOfService } from '@/features/terms-of-service';

export const Route = createFileRoute('/_authenticated/terms-of-service/')({
    head: () => ({ meta: [{ title: 'Terms of Service | promote.fun' }] }),
    component: TermsOfService,
});
